import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import mainConfig from '../config'
import pgLogo from '../images/pyramidgames.png'

const MainContainer = styled.div`
  margin: 0;
  padding: 0;
  width: 100vw;
  height: 100vh;
  text-align: center;
  font-size: 22px;
  overflow-y: auto;
`

const PyramidGamesLogo = styled.img`
  margin-top: 40px;
  max-width: 250px;
`

const GameList = styled.div`
    margin: 30px 0;
`

const GameListItem = styled(Link)`
  display: inline-block;
  margin-top: 10px;
  border-radius: 6px;
  min-width: 300px;
  background-color: #f7941e;
  color: #fff;
  text-decoration: none;
  padding: 10px 30px;
  transition: 0.4s;

  &:hover {
    background-color: #c37518;
  }
`

const HomeView = () => (
    <MainContainer>
        <a href={'https://pyramid.games'} target='_blank' rel='noreferrer'>
            <PyramidGamesLogo src={pgLogo}/>
        </a>
        <GameList>
            Choose the game:<br/>
            {
                mainConfig.map(game => (
                    <GameListItem key={game.slug} to={`/${game.slug}`}>{game.name}</GameListItem>
                ))
            }
        </GameList>
    </MainContainer>
)

export default HomeView
